import { IMaskInput } from "react-imask";
import { BrandTextInput } from "./text_input";
import { forwardRef } from "react";

const Input = forwardRef(function TextMaskCustom(props, ref) {
  return <IMaskInput {...props} mask="(000) 000-0000" inputRef={ref} />;
});

export const BrandPhoneTextInput = ({ ...props }) => {
  return <BrandTextInput {...props} inputComponent={Input} />;
};
